import { useRecordRegionSourceDivergence } from '@/hooks/useSetUserRegionFromToken';

// Render-null host for the divergence record. It lives apart from the region
// writer because the writer runs above `KindePropertiesQueryProvider` on web.
export function RegionSourceDivergenceRecorder() {
  useRecordRegionSourceDivergence();
  return null;
}
